import { render } from "./Dealer.vue?vue&type=template&id=c9ec3526"
import script from "./Dealer.vue?vue&type=script&setup=true&lang=js"
export * from "./Dealer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"source/js/vue/pages/Dealer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c9ec3526"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c9ec3526', __exports__)) {
    api.reload('c9ec3526', __exports__)
  }
  
  module.hot.accept("./Dealer.vue?vue&type=template&id=c9ec3526", () => {
    api.rerender('c9ec3526', render)
  })

}


export default __exports__